export const RouteName = {
  ONBOARDING: 'onboarding',
  ONBOARDING_REQUEST: 'onboardingRequest',
  ONBOARDING_REGISTRATION: 'onboardingRegistration',

  LOGIN: 'login',
  RESET_PASSWORD: 'resetPassword',
  IMPERSONATE: 'impersonate',

  // authorized creditors
  DASHBOARD: 'dashboard',
  VOUCHERS: 'vouchers',
  DEBTORS: 'debtors',
  PERMANENT_DEBTS: 'permanentDebts',
  UNPROCESSED: 'unprocessed',
  MASTER_DATA: 'masterData',
  SETTINGS: 'settings',
  HELP_CENTER: 'helpCenter',
  WORK_QUEUE: 'workQueue',
  UPDATE_PASSWORD: 'updatePassword',
  OPT_IN: 'optIn',
  USER_INFO: 'userInfo',
  CHECK_CONTACT_INFORMATION: 'checkContactInformation'
};

export default RouteName;
